var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInactiveService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1497_24426)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1497_24426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0096 2.22714C11.8856 2.00762 11.7091 1.82527 11.4972 1.69784C11.2853 1.57041 11.0453 1.50225 10.8006 1.5H5.19942C4.95469 1.50225 4.71469 1.57041 4.50281 1.69784C4.29093 1.82527 4.11439 2.00762 3.9904 2.22714L1.18982 7.27286C1.06547 7.49693 1 7.7511 1 8.00983C1 8.26855 1.06547 8.52272 1.18982 8.74679L3.9904 13.7729C4.11439 13.9924 4.29093 14.1747 4.50281 14.3022C4.71469 14.4296 4.95469 14.4978 5.19942 14.5H10.8006C11.0453 14.4978 11.2853 14.4296 11.4972 14.3022C11.7091 14.1747 11.8856 13.9924 12.0096 13.7729L14.8102 8.72714C14.9345 8.50307 15 8.2489 15 7.99017C15 7.73145 14.9345 7.47728 14.8102 7.25321L12.0096 2.22714ZM10.3614 8C10.3614 8.48586 10.2229 8.9608 9.9634 9.36478C9.70393 9.76875 9.33514 10.0836 8.90366 10.2695C8.47217 10.4555 7.99738 10.5041 7.53932 10.4093C7.08126 10.3146 6.6605 10.0806 6.33026 9.73703C6.00002 9.39348 5.77512 8.95577 5.68401 8.47925C5.59289 8.00273 5.63966 7.5088 5.81838 7.05992C5.99711 6.61105 6.29977 6.22739 6.68809 5.95746C7.07642 5.68754 7.53297 5.54346 8 5.54346C8.62627 5.54346 9.2269 5.80227 9.66974 6.26297C10.1126 6.72366 10.3614 7.34849 10.3614 8Z",
    fill: "#FF5A5E"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1497_24426)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0011 10.3765C14.4506 10.3765 15.6261 11.552 15.6261 13.0015C15.6261 14.451 14.4506 15.6266 13.0011 15.6266C11.5516 15.6266 10.3761 14.451 10.3761 13.0015C10.3761 11.552 11.5516 10.3765 13.0011 10.3765ZM12.456 13.8542L11.8133 13.211C11.7038 13.1014 11.7038 12.9228 11.8133 12.8132C11.9229 12.7037 12.1023 12.7044 12.211 12.8132L12.6641 13.2667L13.7912 12.1396C13.9008 12.03 14.0794 12.03 14.1889 12.1396C14.2985 12.2491 14.2983 12.4279 14.1889 12.5373L12.8627 13.8636C12.7533 13.9729 12.5745 13.9731 12.4649 13.8636C12.4619 13.8605 12.4589 13.8574 12.456 13.8542Z",
    fill: "#FF5A5E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 4,
    height: 2,
    fill: "#FF5A5E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1497_24426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2829 13L14.1415 12.1415C14.2196 12.0633 14.2196 11.9368 14.1415 11.8586C14.0633 11.7805 13.9368 11.7805 13.8586 11.8586L13 12.7172L12.1415 11.8586C12.0633 11.7805 11.9368 11.7805 11.8586 11.8586C11.7805 11.9368 11.7805 12.0633 11.8586 12.1415L12.7172 13L11.8586 13.8586C11.7805 13.9368 11.7805 14.0633 11.8586 14.1415C11.8977 14.1805 11.9489 14.2 12 14.2C12.0512 14.2 12.1024 14.1805 12.1415 14.1415L13 13.2829L13.8586 14.1415C13.8977 14.1805 13.9489 14.2 14 14.2C14.0512 14.2 14.1024 14.1805 14.1415 14.1415C14.2196 14.0633 14.2196 13.9368 14.1415 13.8586L13.2829 13Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1497_24426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1497_24426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 -0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1497_24426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(10 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1497_24426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    fill: "white",
    transform: "translate(11.5 11.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveService);
export default __webpack_public_path__ + "static/media/inactive-service.1de5a83c3c573cb7fb5ea9288c2d6172.svg";
export { ForwardRef as ReactComponent };